import React from "react";

import RegisterForm from "../components/auth/RegisterForm";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";

const Register = () => {
  return (
    <div>
      <Header />
      <RegisterForm />
      <Footer />
    </div>
  );
};

export default Register;
